export default __webpack_public_path__ + "static/media/IMG_0298cropped.16de90c3.jpeg";